<template>
  <generic-container
    :title="$t('sms configuration')"
    icon="chat"
    :header_buttons="header_buttons"
  >
    <div class="ui two link cards">
      <div
        class="card"
        v-for="(conf, idx) in configurations"
        :key="idx"
        @click="edit(conf)"
      >
        <div class="content">
          <img
            class="right floated mini ui image"
            src="/images/icons/sms.png"
          />
          <a
            class="ui green right ribbon label"
            v-if="conf.is_default"
            style="margin-bottom:10px"
            >{{ $t("setted as default") }}</a
          >
          <div class="header">
            {{ conf.name }} <small>| {{ $t(conf.setup.provider) }}</small>
          </div>
          <div class="meta">
            {{
              conf.create_date | formatDate(enterprise_setup.simple_date_format)
            }}
          </div>
          <div class="description" v-if="conf.setup.provider == 'grupo_gente'">
            <div class="ui bulleted list">
              <div class="item">
                {{ $t("api url") }}
                <strong>{{ conf.setup.api_url }}</strong>
              </div>
              <div class="item" v-if="conf.setup.campaign">
                {{ $t("campaign") }} <strong>{{ conf.setup.campaign }}</strong>
              </div>
              <div class="item">
                {{ $t("agent") }} <strong>{{ conf.setup.agent }}</strong>
              </div>
              <div class="item" v-if="conf.setup.source">
                {{ $t("source") }} <strong>{{ conf.setup.source }}</strong>
              </div>
            </div>
          </div>
        </div>
        <div class="ui bottom attached basic buttons">
          <!-- <div
            class="ui basic button"
            @click.stop="set_default(conf, idx)"
            v-bind:class="{ disabled: conf.is_default }"
          >
            <i class="green check icon"></i>
            {{ $t("set as default") }}
          </div> -->
          <div class="ui basic button" @click.stop="remove(conf, idx)">
            <i class="red remove icon"></i>
            {{ $t("delete") }}
          </div>
        </div>
      </div>
    </div>
    <sms-modal ref="email_modal" />
  </generic-container>
</template>

<script>
import { local_api, stringify, enterprise_setup } from "@/utils";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import SmsModal from "./SMSModal/SmsModal";
// import DatasourceModal from "./DatasourceModal";
// import DatasourcePermissionModal from "./DatasourcePermissionModal";

export default {
  name: "SMSManagement",
  props: {},
  components: {
    "generic-container": GenericContainer,
    SmsModal,
  },
  filters: filters,
  data() {
    return {
      header_buttons: [
        {
          icon: "green plus",
          click: this.add,
          tooltip: this.$t("add configuration"),
        },
      ],
      configurations: [],
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    add() {
      this.$refs.email_modal.show();
    },
    edit(conf) {
      this.$refs.email_modal.show(conf);
    },
    remove(conf, idx) {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to remove email configuration?"),
        function() {
          local_api(vm, "post", "/settings/messaging/do-remove-email", {
            u: conf.uuid,
          })
            .then(() => {
              vm.configurations.splice(idx, 1);
            })
            .catch((err) => {
              vm.$alertify.error(stringify(err));
            });
        },
      );
    },
    setConfigurations(confs) {
      this.configurations = confs;
    },
  },
  created() {},
  mounted() {
    let vm = this;
    window.jQuery(vm.$refs.secure).checkbox({
      onChange() {
        vm.setup.secure = window.jQuery(vm.$refs.secure).checkbox("is checked");
      },
    });
  },
  watch: {},
};
</script>
